// Top-level layout for authenticated pages. Renders the sticky header
// (logo, nav, user menu) and the active screen. Unauthenticated routes
// (login, register, forgot-password, reset-password, verify-email)
// render their own centered card via `AuthLayout`.
import type { ReactNode } from 'react';
import { NavLink, Link, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '@/auth/AuthContext';

export function AppLayout({ children }: { children?: ReactNode }) {
  const { session, isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="app-shell">
      <header className="app-header">
        <Link to={isAuthenticated ? '/home' : '/login'} className="app-header__brand">
          FieldReport AI
        </Link>
        {isAuthenticated ? (
          <>
            <nav className="app-header__nav" aria-label="Primary">
              <NavLink to="/home" className={({ isActive }) => (isActive ? 'active' : '')}>
                Home
              </NavLink>
              <NavLink to="/workspace" className={({ isActive }) => (isActive ? 'active' : '')}>
                Workspace
              </NavLink>
              <NavLink to="/reports" className={({ isActive }) => (isActive ? 'active' : '')}>
                Reports
              </NavLink>
              <NavLink to="/profile" className={({ isActive }) => (isActive ? 'active' : '')}>
                Profile
              </NavLink>
            </nav>
            <div className="app-header__user">
              <span>{session?.email ?? session?.username}</span>
              <button
                className="btn btn--ghost"
                type="button"
                onClick={async () => {
                  await logout();
                  navigate('/login', { replace: true });
                }}
              >
                Sign out
              </button>
            </div>
          </>
        ) : null}
      </header>
      <main className="app-main">{children ?? <Outlet />}</main>
    </div>
  );
}
